<template>
  <div class="outerLayer">
    <div class="outerLayer_titleArea">
      <div class="titleArea_left">
        <span class="title">音频 （共{{ total || 0 }}条）</span>
      </div>
      <div class="titleArea_right">
        <el-input v-model="pageIfon.voice_name" placeholder="搜索音频" clearable style="margin-right: 10px;" />
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="success" icon="el-icon-upload2" @click="$refs.file.click()">上传音频<input ref="file" style="display:none;" type="file" multiple accept="audio/*" @change="uploadPictures"></el-button>
      </div>
    </div>
    <div v-loading="loading" class="outerLayer_mainArea">
      <ul class="mainArea_ul">
        <li v-for="item in datas" :key="item.id" class="ul_li" :class="{active: selece && item.id === selece.id}">
          <div class="li_left">
            <span>{{ item.path.slice(item.path.indexOf('--')+2, item.path.indexOf('.mp3')) }}</span>
            <span>{{ item.createdAtTime.slice(0, item.createdAtTime.indexOf(' ')) }}<el-button style="margin-left: 10px;" type="primary" size="mini" @click="choose(item)">选择</el-button></span>
          </div>
          <div class="li_right">
            <i
              class="right_icon el-icon-video-play"
              :class="{
                'el-icon-video-pause': selece && (item.id === selece.id)
              }"
              @click="broadcastTemporarily(item)"
            />
            <span>{{ item.duration }}</span>
          </div>
          <!-- <div class="implicit">
            <i class="el-icon-more-outline" />
          </div> -->
        </li>
      </ul>
    </div>

    <PaginationRight
      :total="total"
      :page-sizes="[20]"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { getMaterialLibraryList, newMaterial } from '@/api/sourceMaterial.js'
import { qiniuToken } from '@/api/qiniuToken.js'
import * as qiniu from 'qiniu-js'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      datas: [],
      audioDom: document.createElement('audio'),
      selece: null,
      loading: false,
      total: null,
      pageIfon: {
        type: 2,
        page: 1,
        pageSize: 20,
        voice_name: null
      },
      token: null
    }
  },
  created() {
    // this.getAudioList()
    this.getQiniuToken()
  },
  methods: {
    send() {
      this.getAudioList()
    },
    async getQiniuToken() {
      const data = await qiniuToken()
      this.token = data.data.upToken
    },
    broadcastTemporarily(item) {
      if ((this.selece && item.id !== this.selece.id) || this.audioDom.paused) {
        this.audioDom.src = item.path
        this.audioDom.play()
        this.selece = item
        this.audioDom.onended = () => {
          this.selece = null
        }
      } else {
        this.audioDom.src = null
        this.selece = null
      }
    },
    async getAudioList() {
      this.loading = true
      const data = await getMaterialLibraryList(this.pageIfon)
      this.datas = data.data.list
      this.total = data.data.total
      this.loading = false
    },
    fetchPageSize(num) {
      this.audioDom.src = null
      this.selece = null
      this.pageIfon.pageSize = num
      this.getAudioList()
    },
    fetchCurrentPage(num) {
      this.audioDom.src = null
      this.selece = null
      this.pageIfon.page = num
      this.getAudioList()
    },
    async uploadPictures(e) {
      const fileIfon = e.target.files[0]

      const ftype = fileIfon.name.substr(fileIfon.name.lastIndexOf('.')) // 截取文件格式
      const extension = ftype === '.mp3'
      const extension2 = ftype === '.wma'
      const extension3 = ftype === '.wav'
      const extension4 = ftype === '.amr'
      // eslint-disable-next-line eqeqeq
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: '请上传正确的上传格式(mp3, wma, wav, amr)',
          type: 'error'
        })
        return
      }
      const isLt2M = fileIfon.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 2MB!')
        return
      }
      var timer = await this.getMp4Time(fileIfon)
      if (timer > 60) {
        this.$message.error('音频不能大于60秒s')
        return
      }
      // timer = Math.floor(timer / 60) + ':' + Math.floor(timer - (Math.floor(timer / 60) * 60))
      const observable = qiniu.upload(fileIfon, `user/${Math.random().toString(36).slice(-6) + '--' + fileIfon.name}`, this.token, {
        fname: fileIfon.name // 文件名
      }, {
        useCdnDomain: true // cdn域名加速
      })

      observable.subscribe({
        next() { },
        error(err) {
          console.log(err)
        },
        complete: (data) => {
          newMaterial({
            type: 2,
            size: fileIfon.size,
            key: data.key,
            duration: timer
          }).then(() => {
            this.getAudioList()
            this.audioDom.src = null
            this.selece = null
          })
        }

      })
    },
    getMp4Time(file) {
      return new Promise((resolve, reject) => {
        // 把element上传组件传给我们的file转成url
        const url = URL.createObjectURL(file)
        // 获取对象
        var audioElement = new Audio(url)
        // 监听事件
        audioElement.addEventListener('loadedmetadata', () => {
          const time = Math.round(audioElement.duration * 100) / 100
          resolve(time)
        })
        audioElement.addEventListener('error', () => {
          resolve(0)
        })
      })
    },
    search() {
      this.pageIfon.page = 1
      this.getAudioList()
    },
    choose(item) {
      this.$emit('voicecallback', item)
    }
  }
}
</script>

<style scoped lang="less">
*{

  list-style-type: none;
  box-sizing: border-box;
}
.outerLayer{
   width: 99%;
  //  min-height: calc(100vh - 248px);
   background-color: #fff;
   padding: 10px;
   border-radius: 7px;
   box-shadow: 0px 0px 5px #ccc;
   margin: 0 auto;
   margin-top: 2px;
   margin-bottom: 2px;

   .outerLayer_titleArea{
     display: flex;
     align-items: center;
     justify-content: space-between;
     margin-bottom: 10px;
     .titleArea_left{

     }
     .titleArea_right{
      display: flex;
      align-items: center;
     }
   }

   .outerLayer_mainArea{
      max-height: 550px;
      overflow-y: scroll;
     .mainArea_ul{
       display: flex;
       flex-wrap: wrap;
       padding: 0px;
       margin: 0px;
       .ul_li{
          width: 230px;
          height: 90px;
          box-shadow: 0px 0px 2px #888686;
          border-radius: 9px;
          padding: 10px;
          display: flex;
          justify-content: space-between;
          margin: 10px 20px;
          position: relative;

          .li_left{
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              font-size: 13px;
          }

          .li_right{
              display: flex;
              flex-direction: column;
              width: 60px;
              height: 100%;
              background-color: rgb(218, 218, 218);
              align-items: center;
              justify-content: space-around;
              font-size: 13px;
              .right_icon{
                font-size: 28px;
                cursor: pointer;
                color: #888686;
                &:hover{
                    color: black;
                }
              }
          }
          &.active{
             box-shadow: 0px 0px 5px #0fcf18;
            .implicit{
              display: flex;
            }
          }
          &:not(.active):hover{
            box-shadow: 0px 0px 5px #0fcf18;
            .implicit{
              display: flex;
            }
          }

          .implicit{
               position: absolute;
               width: 21px;
               height: 21px;
               border-radius: 50%;
               box-shadow: 0px 0px 2px black;
               display: none;
               align-items: center;
               justify-content: center;
               cursor: pointer;
               background-color: #fff;
               top: 2px;
               right: 2px;
               &:hover{
                 box-shadow: 0px 0px 5px #0fcf18;
               }
               i{
                 font-size: 18px;
               }
          }
       }
     }
   }
}
</style>
